import React from "react";
import { Typography, makeStyles } from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import OptimizedTooltip from "../common/OptimizedTooltip";

const useStyles = makeStyles(theme => ({
  fontWeightMedium: {
    fontWeight: 500
  },
  addressSubtitle: {
    width: "90%",
    fontSize: "0.8125rem"
  },
  addressTitle: {
    width: "90%"
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: theme.spacing(0.5)
  },
  titleWrapper: {
    display: "flex",
    alignItems: "center"
  }
}));

export default function StopInfo({ stopInfo, isSuggestion, isLocked }) {
  const classes = useStyles();
  //'Cause there stopInfo[0] is not just text and component with props so for tooltip we need to show text that holds in component props 
  // We show tooltip only when text length is bigger for allowed size
  const shouldShowTooltip = stopInfoComponent => stopInfoComponent?.props?.text?.length > 28 ? stopInfoComponent?.props?.text : "";


  return (
    <>
      <Typography
        id="addStop-selectedStopTitle"
        className={classes.titleWrapper}
        variant="body2"
      >
        {isLocked && <LockIcon className={classes.icon} />} 
        <OptimizedTooltip title={`${shouldShowTooltip(stopInfo[0])}`}>
              <Typography variant="body2" noWrap className={classes.addressTitle}>{stopInfo[0]}</Typography>
        </OptimizedTooltip>
      </Typography>
      <OptimizedTooltip title={`${shouldShowTooltip(stopInfo[1])}`}>
        <Typography
          variant="body2"
          className={classes.addressSubtitle}
          color="secondary"
          noWrap
        >
          {stopInfo[1]}
        </Typography>
      </OptimizedTooltip>
    </>
  );
  // <>
  //   {stop.information &&
  //     (stop.information.recipient_name ? (
  //       <>
  //         <Typography
  //           variant="body2"
  //           className={classes.fontWeightMedium}
  //           data-cy="stop-recipientName"
  //           noWrap
  //         >
  //           {stop.information.recipient_name || <>&#8203;</>}
  //         </Typography>

  //         <Typography
  //           variant="body2"
  //           className={classes.addressSubtitle}
  //           color="secondary"
  //           noWrap
  //         >
  //           {stop.information.street || ""}
  //           {stop.information.street ? "," : ""}
  //           {stop.information.city ? ` ${stop.information.city}` : ""}
  //           {stop.information.street
  //             ? ""
  //             : stop.information.country
  //             ? (stop.information.city && stop.information.country
  //                 ? ", "
  //                 : "") + getCountryName(stop.information.country)
  //             : ""}
  //         </Typography>
  //       </>
  //     ) : (
  // <>

  // </>

  // ))}
  // </>
  // <>
  //   <Typography
  //     variant="body2"
  //     data-cy="stop-recipientName"
  //     noWrap
  //   >
  //     {stopInfo.description?.split(",")[0]}
  //   </Typography>

  //   <Typography
  //     variant="body2"
  //     className={classes.addressSubtitle}
  //     color="secondary"
  //     noWrap
  //   >
  //     {stopInfo.description?.split(",").slice(1).join(",")}
  //   </Typography>
  // </>
}
